export default __webpack_public_path__ + "static/earth-badge-3bab0f971b70e19ccf6c7c08a996839f.svg";